module.exports = __webpack_public_path__ + "img/category-skill-game.46bbdf4a.png";